import type { ComponentProps } from 'react';

import { OnboardingStepLayout } from '@sorare/gameplay/src/components/onboarding/OnboardingStepLayout';

export const MarketGuidanceLayout = (
  props: ComponentProps<typeof OnboardingStepLayout>
) => {
  return <OnboardingStepLayout {...props} />;
};
